import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterFoods',
    standalone: false
})
export class FilterFoodsPipe implements PipeTransform {
  transform(foods: any[], allowedStatuses: string[]): any[] {
    if (!foods || !allowedStatuses || allowedStatuses.length === 0) {
      return [];
    }
    return foods.filter(food => allowedStatuses.includes(food.status));
  }
}